<script>
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import SeekBackIcon from '../icons/SeekBackIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
</script>

<ControlBarButton
  onclick={() => videoStore.state.videoController?.seekBackward()}
  tooltip={translationsStore.state.seek_backward}
>
  <SeekBackIcon />
</ControlBarButton>
